import { useState, useEffect } from "react"
import { Settings } from "lucide-react"
import { Button } from "@/components/ui/button"
import ManagePreferencesModal from "./manage-preferences"

export default function CookiePreferencesIcon({ onOpenModal }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    // Check if any cookie preferences have been set (meaning consent was given or rejected)
    const preferencesSet = localStorage.getItem("cookie_preferences")
    if (preferencesSet) {
      setIsVisible(true)
    }

    // Listen for changes in localStorage (e.g., if the banner is accepted or rejected)
    const handleStorageChange = (event) => {
      if (event.key === "cookie_preferences") {
        if (event.newValue) {
          setIsVisible(true)
        } else {
          setIsVisible(false) // If preferences are cleared, hide the icon
        }
      }
    }

    window.addEventListener("storage", handleStorageChange)
    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  const handleOpenModal = () => {
    setIsModalOpen(true)
    onOpenModal()
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSavePreferences = (preferences) => {
    // The modal itself handles saving to localStorage, so we just log here
    console.log("Cookie preferences saved via icon:", preferences)
  }

  if (!isVisible) {
    return null
  }

  return (
    <>
      <Button
        variant="secondary"
        size="icon"
        className="fixed bottom-20 md:bottom-6 left-4 z-40 rounded-full shadow-lg bg-gray-800 text-white hover:bg-gray-700 transition-all duration-300"
        onClick={handleOpenModal}
        aria-label="Manage Cookie Preferences"
      >
        <Settings className="h-5 w-5" />
      </Button>
      <ManagePreferencesModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSavePreferences={handleSavePreferences}
      />
    </>
  )
}
